import * as React from 'react';

export interface RepPayeeIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * RepPayeeIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description SSA Representative Payee. REP/PAYEE document with SSA shield corner badge.
 */
const RepPayeeIcon: React.FunctionComponent<RepPayeeIconProps> = ({
  className,
  size = 40,
  title = 'SSA Representative Payee',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#185FA5" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#185FA5"/>
      <text x="25" y="20" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="7" fontWeight="900" fill="#185FA5" letterSpacing="0.4">REP</text>
      <text x="25" y="28" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="7" fontWeight="900" fill="#185FA5" letterSpacing="0.4">PAYEE</text>
      <line x1="14" y1="32" x2="36" y2="32" stroke="#185FA5" strokeWidth="0.8"/>
      <line x1="14" y1="35" x2="32" y2="35" stroke="#185FA5" strokeWidth="0.8"/>
      <path d="M30 37 L38 37 L38 41 Q38 43 34 44 Q30 43 30 41 Z" fill="#185FA5"/>
      <text x="34" y="42" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="3" fontWeight="900" fill="#FFFFFF" letterSpacing="0.4">SSA</text>
  </svg>
);

export default RepPayeeIcon;
